import { useState } from 'react';
import { Plus, Send, Clock, CheckCircle2, AlertCircle, Eye, MousePointer2, Trash2, Copy } from 'lucide-react';
import CampaignDetailsModal from '@ComponentViews/CampaignDetailsModal';
import './EmailCampaignsPage.scss';

const CAMPAIGNS = [
    { id: '1', name: 'Product Launch Q3', type: 'Email', status: 'Running', sent: 2540, openRate: 42.5, clickRate: 8.2, date: 'Oct 15, 2023' },
    { id: '2', name: 'Welcome Series Auto', type: 'Email', status: 'Running', sent: 128, openRate: 68.1, clickRate: 24.5, date: 'Ongoing' },
    { id: '3', name: 'Discount Promo Weekend', type: 'Email', status: 'Completed', sent: 5000, openRate: 31.2, clickRate: 4.8, date: 'Oct 08, 2023' },
    { id: '4', name: 'Newsletter Nov', type: 'Email', status: 'Draft', sent: 0, openRate: 0, clickRate: 0, date: 'Nov 01, 2023' },
    { id: '5', name: 'Customer Feedback Survey', type: 'Email', status: 'Paused', sent: 850, openRate: 15.4, clickRate: 2.1, date: 'Sep 28, 2023' },
];

function EmailCampaignsPage() {

    const [showForm, setShowForm] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Running': return { icon: <Clock size={14} />, className: 'status-running' };
            case 'Completed': return { icon: <CheckCircle2 size={14} />, className: 'status-completed' };
            case 'Draft': return { icon: <AlertCircle size={14} />, className: 'status-draft' };
            case 'Paused': return { icon: <AlertCircle size={14} />, className: 'status-paused' };
            default: return { icon: null, className: 'status-default' };
        }
    };

    const toggleAddCampaignsForm = ()=> {
        setShowForm(!showForm);
    }

    return (
        <div className="email-campaigns-root">
            <div className="email-campaigns-main-grid">
                <div className="email-campaigns-campaigns">
                    <h3 className="email-campaigns-section-title">Recent Campaigns</h3>
                    <div className="email-campaigns-list">
                        {CAMPAIGNS.map((campaign) => {
                            const status = getStatusBadge(campaign.status);
                            return (
                                <div
                                    key={campaign.id}
                                    className="email-campaigns-item"
                                    onClick={() => setSelectedCampaign(campaign)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="email-campaigns-item-row">
                                        <div className="email-campaigns-item-main">
                                            <div className="email-campaigns-item-title-row">
                                                <h4 className="email-campaigns-item-title">{campaign.name}</h4>
                                                <span className={`email-campaigns-status-badge ${status.className}`}>
                                                    {status.icon}
                                                    {campaign.status}
                                                </span>
                                            </div>
                                            <p className="email-campaigns-item-meta">Created: {campaign.date} • {campaign.sent.toLocaleString()} Sent</p>
                                        </div>
                                        <div className="email-campaigns-item-stats">
                                            <div className="email-campaigns-item-stat">
                                                <div className="email-campaigns-item-stat-value">{campaign.openRate}%</div>
                                                <div className="email-campaigns-item-stat-label">Open Rate</div>
                                            </div>
                                            <div className="email-campaigns-item-stat">
                                                <div className="email-campaigns-item-stat-value">{campaign.clickRate}%</div>
                                                <div className="email-campaigns-item-stat-label">Click Rate</div>
                                            </div>
                                            <div className="email-campaigns-item-actions">
                                                <button onClick={(e) => e.stopPropagation()}><Copy size={16} /></button>
                                                <button onClick={(e) => e.stopPropagation()}><Trash2 size={16} /></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="email-campaigns-side">
                    <div className="email-campaigns-assistant">
                        <h3>Campaign Assistant</h3>
                        <p>Use our AI-powered assistant to generate high-converting subject lines and email content for your next campaign.</p>
                        <button className="email-campaigns-btn-draft">Try Smart Draft</button>
                    </div>
                    <div className="email-campaigns-quickstats">
                        <h3>Quick Stats</h3>
                        <div className="email-campaigns-quickstats-list">
                            <div className="email-campaigns-quickstats-item">
                                <div className="email-campaigns-quickstats-icon send"><Send size={18} /></div>
                                <div>
                                    <div className="email-campaigns-quickstats-label">Monthly Emails Sent</div>
                                    <div className="email-campaigns-quickstats-value">12,482 / 20,000</div>
                                    <div className="email-campaigns-quickstats-bar">
                                        <div className="email-campaigns-quickstats-bar-inner" style={{ width: '62%' }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="email-campaigns-quickstats-item">
                                <div className="email-campaigns-quickstats-icon open"><Eye size={18} /></div>
                                <div>
                                    <div className="email-campaigns-quickstats-label">Avg. Open Rate</div>
                                    <div className="email-campaigns-quickstats-value">45.2%</div>
                                </div>
                            </div>
                            <div className="email-campaigns-quickstats-item">
                                <div className="email-campaigns-quickstats-icon click"><MousePointer2 size={18} /></div>
                                <div>
                                    <div className="email-campaigns-quickstats-label">Avg. Click Rate</div>
                                    <div className="email-campaigns-quickstats-value">12.8%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedCampaign && (
                <CampaignDetailsModal
                    campaign={selectedCampaign}
                    channelType="Email"
                    onClose={() => setSelectedCampaign(null)}
                />
            )}
        </div>
    );
}

export default EmailCampaignsPage;
